import ILanguage from "@/admin/helpers/interfaces/language-types";
import { API_SITE_CORPO } from "../api_endpoint";
import { http  } from '../http';
 


 
export const saveTranslation = async (translation: any) => {  
	try {
		
		let endPoint= API_SITE_CORPO.TRANSLATION
		let { data } = await http.post(endPoint,translation);

		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};

export const importTranslation =async (file: File) => {
	try {
		let x=API_SITE_CORPO.TRANSLATION +"/import"
		let { data } = await http.post(x, file);
		return data;
	} catch (error: any) {
		const errorMessage = error.response && error.response.data ? error.response.data.errors : 'An error occurred while processing your request. Please try again.';
		throw errorMessage; 
	}
}